import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@pm-ui/core-services';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'auth',
        pathMatch: 'full'
    },
    {
        path: 'workorderpage',
       loadChildren: () => import('./workorderpage/workorderpage.module').then(m => m.WorkOrderPageModule)
    },
    {
      path: 'purchaseorderpage',
     loadChildren: () => import('./purchaseorderpage/purchaseorderpage.module').then(m => m.PurchaseOrderPageModule)
  },
    {
      path: 'task',
      loadChildren: () => import('./task/task.module').then(m => m.TaskModule)
  },
    {
        path: 'subTask',
        loadChildren: () => import('./subtask/subtask.module').then(m => m.SubTaskModule)
    },
    {
        path: 'purchase-order',
        loadChildren: () => import('./purchase-order/purchase-order.module').then(m => m.PurchaseOrderModule)
    },
    {
        path: 'work-order',
        loadChildren: () => import('./work-order/work-order.module').then(m => m.WorkOrderModule)
    },
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
    },
    {
        path: 'admin',
        canActivate: [AuthGuard],
        data: { portalType: 'admin' },
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
    },
    {
        path: '**',
        redirectTo: 'auth',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
